module.exports = __webpack_public_path__ + "img/DSC_2926-xs.bb4afa81.png";